export const training = {
    route: 'Smart Training',
    selectDevice: 'Select device',
    saveEvent: 'Save event',
    changeEvent: 'Change event',
    addNew: 'Add new ...',
    saveSelected: 'Save selected events',
    l1unknown: 'L1 Unknown',
    l2unknown: 'L2 Unknown',
    l3unknown: 'L3 Unknown',
    l123unknown: '3 Phase Unknown',
    l1devices: 'L1 Devices',
    l2devices: 'L2 Devices',
    l3devices: 'L3 Devices',
    l123devices: '3 Phase Devices',
    unknownDevice: 'Unknown device',
    deleted: 'Deleted',
    filterDevice: 'Filter:',
    unknownDevices: 'Unknown devices',
    none: 'None',
    zoomSelection: 'Zoom selection',
    clearSelection: 'Clear selection/zoom',
    clearZoom: 'Clear zoom',
    groupBy: 'Group by',
    groupByPhases: 'Phases',
    groupByDevices: 'Devices',
    groupBy5Clusters: '5 Clusters',
    groupBy10Clusters: '10 Clusters',
    groupBy20Clusters: '20 Clusters',
    unknown: 'Unknown',
    others: 'Other devices',
    cluster: 'Cluster',
    smartTipsTitle: 'How to use smart training ?',
    smartTips: [
        { key: 0 , text: 'Here you can see all the events which have happened in your household in past 30 days. To see specific period of time, move the slider handles on top of the graph.'},
        { key: 1 , text: 'By default, events are grouped by phase, but you can select other options like group by device or different cluster sizes from select box located on top right.'},
        { key: 2 , text: 'You can use your mouse wheel or touchpad to zoom on events and also drag the graph to pan it. If you want to go back to original viewport, use buttons on top right to clear zoom and/or selection.'},
        { key: 3 , text: 'There are two types of events, events which are already assigned to a device (small circles) and those which are unknown (big circles).'},
        { key: 4 , text: 'To assign unknown events to a device, click and select them, then press "Save selected events" button. There you can either create a new device for selected events or assign them to an existing device.'}
    ],
    selectPeriod: 'Select period',
    last2min: 'Last 2 minutes',
    last5min: 'Last 5 minutes',
    last10min: 'Last 10 minutes',
    last30min: 'Last 30 minutes',
    last1hour: 'Last 1 hour',
    last3hours: 'Last 3 hours',
    last6hours: 'Last 6 hours',
    last12hours: 'Last 12 hours',
    last24hours: 'Last 24 hours',
    today: 'Today',
    yesterday: 'Yesterday',
    thisWeek: 'This week',
    lastWeek: 'Last week',
    thisMonth: 'This month',
    lastMonth: 'Last month',
    thisQuarter: 'This quarter',
    lastQuarter: 'Last quarter',
    thisYear: 'This year',
    lastYear: 'Last year',
    otherPeriod: 'Other up to 1 year',
    durationError: 'Duration above 1 year',
    from: 'From',
    to: 'To',
    powerUsageLabel: 'POWER USAGE  WATT / VAR',
    recognitionTblNameCol: 'Name',
    recognitionTblCountCol: 'Count',
    recognitionTblWattCol: 'Live Watt',
    recognitionTblWattHoursCol: 'Watt Hours',
    recognitionTblPercentCol: 'Percent',
    recognitionTblSelectedCol: 'Selected',
    alwaysOnTblDayCol: 'Day',
    alwaysOnTblP1Col: 'Phase 1',
    alwaysOnTblP2Col: 'Phase 2',
    alwaysOnTblP3Col: 'Phase 3',
    totalKwh: 'Usage kWh',
    recognitionKwh: 'Recognition kWh',
    classificationKwh: 'Classification kWh',
    alwaysOnKwh: 'Always On kWh',
    completeness24h: 'Completeness of raw data (Last 24 hours)',
    completeness1h: 'Completeness of raw data (Last 60 minutes)',
    recognitionRate: 'Recognition Rate',
    recognitionCorrectness: 'Recognition Correctness',
    classificationRate: 'Classification Rate',
    recognitions: 'Recognitions',
    recognitionsMobile: 'Live Power Usage',
    alwaysOnPerDay: 'Always On per Day',
    singleGraphYLabel: 'POWER USAGE / TEMPERATURE',
    singleGraphUsage: 'Power usage',
    singleGraphTemp: 'Temperature',
    singleGraphStatus: 'Status',
    addonGraphYLabel: 'PREMIUM DATA',
    kwhCost: 'cost pro kilowatt',
    wattUnit: 'Watt',
    wUnit: 'W',
    kwUnit: 'Kilowatt',
    mwUnit: 'Megawatt',
    kwhUnit: 'KWh',
    kgUnit: 'Kilogram',
    costUnit: '€',
    var: 'VAR',
    periodPicker: 'Period (up to 7 days)',
    deviceAssistant: 'Device Assistant',
    meterShortName: 'Meter short name (optional)',
};
